import { Component, OnInit, Input,HostListener, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertsService } from '../../services/alerts.service';
import { LoaderService } from '../../services/loader.service';
import { AppService } from '../../shared/services/app.service';
import { BaseService } from '../../shared/services/base.service';
import { DownloadService } from '../../shared/services/download.service';
import { StorageService } from '../../shared/services/storage.service';
import { PrintService } from '../../shared/services/print.service';
import { UtilService } from '../../services/util.service';
import { Location } from '@angular/common';
import { AuthenticationService } from 'src/modules/base/shared/services/authentication.service';
import { forEach } from 'lodash';

@Component({
    selector: 'quick-download',
    templateUrl: './quick-download.component.html',
    styleUrls: ['./quick-download.component.scss'],
    standalone: false
})
export class QuickDownloadComponent implements OnInit,AfterViewInit {
  currentData: any = {show:false,imageInfo: [{ name: '', contentType: 'application/png' }], filterBlock: { default_open: true } };
  QrcodeHasError=false;
  constructor(
    public appService: AppService,
    public baseService: BaseService,
    private alertService: AlertsService,
    private downloadService: DownloadService,
    private storageService: StorageService,
    private loader: LoaderService,
    public route: ActivatedRoute,
    public router: Router,
    public printService: PrintService,
    public alerts: AlertsService,
    public utilService: UtilService,
    private location: Location,
    private authenticationService: AuthenticationService
  ) { }

  ngOnInit(): void {
    if(this.route.snapshot.params.id != undefined && this.route.snapshot.queryParams!=undefined && this.route.snapshot.queryParams.printType==undefined){
      var userId = this.route.snapshot.params.user_id;
      var downloadId = this.route.snapshot.params.id;
      var dataSource = {
        "resource": "requested_downloads",
        "application": "bulk-download",
        
      }
      this.loader.showSpinner();
      this.baseService.getById(downloadId, dataSource.resource, dataSource.application).subscribe(
        (data: any) => {
          if (data.erroCode == -1) {
            this.alertService.error(data.message);
          } else {
            this.loader.hideSpinner();
            if(data.user_ids != undefined && Array.isArray(data.user_ids) && data.user_ids.length>0 && data.user_ids.indexOf(userId)>-1){
              var menuData = {
                "key": "id",
                "action": "format_bulk_download",
                "action_name": "download"
              }
              var menuObj = {
                actionType:menuData,
                data:data
              }
              this.downloadService.formatCSV(menuObj,()=>{
                  console.log("DOWNLOAD DONE");
                  document.getElementById("download-container").innerHTML = "Download Completed";
                  this.logoutIfAutoDownload(()=>{});
              });
            }else{
              this.alertService.info("idnf");
              document.getElementById("download-container").innerHTML = "Download not found";
              this.logoutIfAutoDownload(()=>{
                this.router.navigate(["/login"]);
              });
            }
          }
        }, error => {
          console.error(error);
          this.alertService.error('API error');
          this.loader.hideSpinner();
          this.logoutIfAutoDownload(()=>{
            this.router.navigate(["/login"]);
          });
        }
      )
    }else if(this.route.snapshot.params.id != undefined && this.route.snapshot.queryParams !=undefined && this.route.snapshot.queryParams.printType=="misReport"){
     this.downloadPrint();
    }
    else if(this.route.snapshot.queryParams !=undefined && this.route.snapshot.queryParams.printType =="QRCode"){
      this.qrCodePrint();
    }
    else{
      this.alertService.info("idnf");
      this.logoutIfAutoDownload(()=>{
        this.router.navigate(["/login"]);
      });
    }
  } 

  logoutIfAutoDownload(callback){
    if(this.storageService.getLocalStorageDataSync("auto_login")){
      this.storageService.removeData("currentUser",()=>{})
      this.appService.logout(() => {
        this.storageService.reloadOtherTab();
        callback()
      });
    }
  }
 
  ngAfterViewInit() {
    if(document.getElementById("download-container") !=undefined && this.QrcodeHasError){
      document.getElementById("download-container").innerHTML = "Document Not Found";
    }
  }
  downloadPrint(){
    var downloadId = this.route.snapshot.params.id;
    var dataSource = {
      "resource": "async_downloads",
      "application": "printengine",
      
    }
    this.loader.showSpinner();
    this.baseService.getById(downloadId, dataSource.resource, dataSource.application).subscribe(
      (data: any) => {
        if (data.erroCode == -1) {
          this.alertService.error(data.message);
        } else {
          this.loader.hideSpinner();
          if(data.print_url !=undefined){
            let imageurl = "/dms/api/v1/" + "async_print_document" + "/image-response-entity?path=" + data.print_url;
            this.baseService.getFileByUrl(imageurl, false).subscribe(res => {
              if (res) {
                this.baseService.downloadFile(res,res.type,"",()=>{
                  console.log("DOWNLOAD DONE");
                  document.getElementById("download-container").innerHTML = "Download Completed";
                  this.logoutIfAutoDownload(()=>{});
                });
              } else {
                this.alertService.info("idnf");
                document.getElementById("download-container").innerHTML = "Document Not Found";
                this.logoutIfAutoDownload(()=>{
                  this.router.navigate(["/login"]);
                });
              }
            })
          }else{
            this.alertService.info("idnf");
            document.getElementById("download-container").innerHTML = "Document Not Found";
            this.logoutIfAutoDownload(()=>{
              this.router.navigate(["/login"]);
            });
          }
        }
      }, error => {
        console.error(error);
        this.alertService.error('API error');
        this.loader.hideSpinner();
        this.logoutIfAutoDownload(()=>{
          this.router.navigate(["/login"]);
        });
      }
    )
  }

  qrCodePrint(){
    let serviceTypeCode = this.route.snapshot.queryParams.serviceType_code;
    let folder = this.route.snapshot.queryParams.folder;
    let facility_id = this.route.snapshot.queryParams.facility_id;
    let serviceRequestId=this.route.snapshot.queryParams.serviceRequestId;
    let application="diagnostic";
    let resource="observation";
    let template="cumulative";
    let args="facility_id:"+facility_id+",uhId:"+this.route.snapshot.queryParams.uhId+",serviceType_code:"+serviceTypeCode+",patientId:"+this.route.snapshot.params.user_id+",userPrint:Y,use-dynamic-resource:true,QRCodePrint:true";
   
    if(serviceRequestId !=undefined && serviceRequestId !=""){
      args+=",serviceRequestId:"+serviceRequestId+",primaryKeyIdentifier:"+serviceRequestId;
    }else if(this.route.snapshot.queryParams.orderId !=undefined && this.route.snapshot.queryParams.orderId !=""){
      args+=",orderId:"+this.route.snapshot.queryParams.orderId;
    }

    //For laboratory
    if(serviceTypeCode !=undefined && serviceTypeCode=="pathology"){
      this.loader.showSpinner();
      this.baseService.get("GET_CUMULATIVE_PRINT",args,resource,application).subscribe((res)=>{
        this.loader.hideSpinner();
        if(res.errCode==0 && res.resource.length >0){
         let obj=res.resource[0];
         if(serviceRequestId !=undefined && serviceRequestId !=""){
          template=this.getTemplateId(res.resource);
         }
         if(obj.uploadedDocumentId !=undefined){
           this.handleS3File(folder,obj.uploadedDocumentId);
         }else{
          let fileObj={
           "application":application,
           "resource":"observation",
           "query_id":"GET_CUMULATIVE_PRINT",
           "template":template,
           "args":args,
           "contentType":"pdf"
          }
          this.handleFile(fileObj);
         }
        }else if(res.errCode==-1){
          this.alerts.error(res.message);
          this.QrcodeHasError=true;
          if(document.getElementById("download-container") !=undefined){
            document.getElementById("download-container").innerHTML = res.message;
          }
        }
        else{
          this.QrcodeHasError=true;
          if(document.getElementById("download-container") !=undefined){
            document.getElementById("download-container").innerHTML = "Document Not Found";
          }
        }
       })
    } //For other
    else if(serviceTypeCode !=undefined && (serviceTypeCode=="radiology" || serviceTypeCode=="cardiology" || serviceTypeCode=="pulmonology" || serviceTypeCode=="neurology" || serviceTypeCode=="nuclear_medicine") ){
      this.loader.showSpinner();
      this.baseService.get("GET_MULTIPLE_RIS_REPORTS_PER_UHID",args,resource,application).subscribe((res)=>{
        this.loader.hideSpinner();
        if(res.errCode==0 && res.resource.length >0){
         let obj=res.resource[0];
         if(serviceRequestId !=undefined && serviceRequestId !=""){
          template=this.getTemplateId(res.resource);
         }else{
          template="combined";
         }
        if(obj.uploadedDocumentId !=undefined){
           this.handleS3File(folder,obj.uploadedDocumentId);
         }else{
          let fileObj={
           "application":application,
           "resource":"observation",
           "query_id":"GET_MULTIPLE_RIS_REPORTS_PER_UHID",
           "template":template,
           "args":args,
           "contentType":"pdf"
          }
           this.handleFile(fileObj); 
         }
        }
        else if(res.errCode==-1){
          this.alerts.error(res.message);
          this.QrcodeHasError=true;
          if(document.getElementById("download-container") !=undefined){
            document.getElementById("download-container").innerHTML = res.message;
          }
        }
        else{
          this.QrcodeHasError=true;
          if(document.getElementById("download-container") !=undefined){
            document.getElementById("download-container").innerHTML = "Document Not Found";
          }
        }
       })
    }else{
      this.QrcodeHasError=true;
      if(document.getElementById("download-container") !=undefined){
        document.getElementById("download-container").innerHTML = "Document Not Found";
      }
    }
    
  }

  handleS3File(folder,documentId){
    let imageurl = "/dms/api/v1/" + folder + "/image-response-entity?path=" + documentId;
    this.baseService.getFileByUrl(imageurl, false).subscribe(res => {
      if (res) {
        this.setPdfViewerData(res);
      } else {
        this.alertService.info("idnf");
        document.getElementById("download-container").innerHTML = "Document not found";
      }
    })
  }


  handleFile(fileObj){
    this.baseService.handleFile(fileObj, async (fileData) => {
      if (fileData) {
        if (fileData.type == "application/json") {
          try {
            var response = await fileData.text();
            response = JSON.parse(response);
          
            if (response.errCode == -1 && response.message != undefined) {
              this.alerts.error(response.message);
            }
           
            console.log(response);
          } catch (e) {
            this.alerts.error('API error');
          }
        } else {
          this.setPdfViewerData(fileData);
          document.getElementById("download-container").innerHTML = "Download Completed";
        }
      } else {
        document.getElementById("download-container").innerHTML = "Document Not Found";
        this.alerts.error('server error');
      }
    });
  }

  setPdfViewerData(fileData){
    this.currentData.imageInfo[0].contentType = fileData.type;
    this.currentData.type = fileData.type;
    const blobTest = new Blob([fileData], { type: fileData.type });
    this.currentData.labReport = URL.createObjectURL(blobTest);
    this.loader.hideSpinner();
    this.currentData.show = true;
  }

  getTemplateId(res){
    let template="cumulative";
    let printData:any;
    if(res !=undefined && res.length >1){
      for(let i=0;i<res.length;i++){
        printData=res[i];
        if(printData.labServiceType !=undefined && (printData.labServiceType=="test" || printData.labServiceType=="testprofile")){
          printData=res[i];
          break;
        }
      }
    }else if(res !=undefined && res.length ==1){
      printData=res[0];
    }
   
    if (printData.serviceType_code == 'pathology' && printData.resultType != 'template' && printData.isOutsourced == false && printData.isMultiStage == false){
     return "diagnostic";
    }
    else if (printData.serviceType_code == 'pathology' && printData.resultType != 'template' && printData.isMultiStage == true && printData.isOutsourced == false){
      return "antibiotic";
    }
    else if (printData.serviceType_code == 'pathology' && printData.resultType == 'template' && printData.isOutsourced == false){
      return "templateDiagnostic";
    }
    else if ((printData.serviceType_code == 'radiology' || printData.serviceType_code == 'cardiology' || printData.serviceType_code == 'pulmonology' || printData.serviceType_code == 'neurology' || printData.serviceType_code == 'nuclear_medicine') && printData.resultType != 'template' && printData.isOutsourced == false){
      return "ris";
    }
    else if ((printData.serviceType_code == 'radiology' || printData.serviceType_code == 'cardiology' || printData.serviceType_code == 'pulmonology' || printData.serviceType_code == 'neurology' || printData.serviceType_code == 'nuclear_medicine') && printData.resultType == 'template' && printData.isOutsourced == false){
      return "templateDiagnostic";
    }else{
      return template;
    }
  }
}
